import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { PrimaryLink } from './Buttons';
import { services } from '../data/services';
import { contact } from '../data/contact';
export function Services() {
  return <section id="servicios" aria-labelledby="servicios-title" className="relative border-t border-silver/10 bg-indigo-deep py-20 sm:py-28" data-id="element-152" data-mp="18vqzrtn0qljk">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-153" data-mp="z54scmpgh1by">
        <SectionHeading id="servicios-title" eyebrow="Consultas y rituales" title="PRÁCTICAS ESPIRITUALES PERSONALIZADAS" data-id="element-154" data-mp="z3lcuybmiub8" />

        <ul className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-155" data-mp="q4ztj0ybvb9e">
          {services.map((service, index) => <motion.li key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.6,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className="group overflow-hidden rounded-2xl border border-silver/15 bg-carbon shadow-card transition-colors duration-300 hover:border-accent-soft/40" data-id="element-156" data-mp="l5n0fygv57yd" data-mpi={index}>
              <div className="relative aspect-[4/3] overflow-hidden bg-carbon" data-id="element-157" data-mp="32avzk11mk1ex">
                <img src={service.image} alt={service.imageAlt} className="h-full w-full object-cover opacity-75 [filter:saturate(0.45)_contrast(1.05)_brightness(0.9)] transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-158" data-mp="328ryrrz0viiv" />
                <div aria-hidden="true" className="absolute inset-0 bg-night/50 mix-blend-color" data-id="element-159" data-mp="3l13z696489qd" />
                <div aria-hidden="true" className="absolute inset-0 bg-violet-deep/40 mix-blend-multiply" data-id="element-160" data-mp="24lj7thg95h9h" />
                <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/35 to-transparent" data-id="element-161" data-mp="1pkm660j1pxvr" />
              </div>
              <div className="border-t border-silver/10 bg-violet-dark/40 p-7" data-id="element-162" data-mp="1gr94oa6x1ny2">
                <h3 className="flex items-start gap-3 font-display text-lg font-light leading-snug tracking-[0.08em] text-frost sm:text-xl" data-id="element-163" data-mp="1bsxrpqlbqxbm">
                  <span aria-hidden="true" className="text-base leading-7" data-id="element-164" data-mp="16ue31ifcj7fk">
                    {service.emoji}
                  </span>
                  <span data-id="element-165" data-mp="11wusashuxcsd">{service.title}</span>
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-silver sm:text-[0.95rem]" data-id="element-166" data-mp="xtptazwzjt8h">
                  {service.description}
                </p>
              </div>
            </motion.li>)}
        </ul>

        <div className="mt-12 flex justify-center" data-id="element-167" data-mp="2s661w7d97jgi">
          <PrimaryLink href={contact.whatsappHref} className="w-full sm:w-auto" data-id="element-168" data-mp="2n7l2ub9qn5tn">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-169" data-mp="2urn9mevbcho6" />
            Consultar por WhatsApp
          </PrimaryLink>
        </div>
      </div>
    </section>;
}